import { UNKNOWN_FLAG_URL, getFlagUrl } from '@/components/ui/design-system/assets/flags';
import { handleUnitedKingdomException } from '@/lib/countries';
import { cn } from '@/lib/utils';
import type { CountryCode } from 'libphonenumber-js';

const getFlagPath = (countryCode: CountryCode | undefined): string =>
  getFlagUrl(countryCode ? handleUnitedKingdomException(countryCode) : undefined);

export const CountryFlag = ({
  countryCode,
  size = 'm',
}: {
  countryCode: CountryCode | undefined;
  size?: 's' | 'm' | 'l' | 'xl';
}) => {
  // Figma Design System sizes: 12px, 14px, 16px, 20px
  const sizeConfig = {
    s: {
      container: 'size-[12px]',
      radius: 'rounded-xs',
    },
    m: {
      container: 'size-[14px]',
      radius: 'rounded-xs',
    },
    l: {
      container: 'size-[16px]',
      radius: 'rounded-xs',
    },
    xl: {
      container: 'size-[20px]',
      radius: 'rounded-sm',
    },
  };

  const config = sizeConfig[size];
  const flagPath = getFlagPath(countryCode);

  return (
    <div
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden border-1 border-primary-10',
        config.container,
        config.radius,
      )}
    >
      <img
        src={flagPath}
        alt={countryCode ? `${countryCode} flag` : 'Unknown flag'}
        className="h-full w-full object-cover"
        aria-hidden="true"
        onError={(e) => {
          // Fallback to unknown flag if the specific flag image is missing
          if (UNKNOWN_FLAG_URL && e.currentTarget.src !== UNKNOWN_FLAG_URL) {
            e.currentTarget.src = UNKNOWN_FLAG_URL;
          }
        }}
      />
    </div>
  );
};
